import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { ModuleName } from '../subscription-package';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { AuthGuard } from '../core/authentication/auth.guard';
import { Permission } from '../common/enums/permissions';

const routes: Routes = [
    { 
        path: 'reports', 
        component: ReportsListComponent,
        canActivate: [
          AuthGuard,
          PermissionGuard
        ],
          data: {
            permissions: [ 
              Permission.ManageReports
             ], 
            moduleName: ModuleName.Reports,
          }, 
    } 
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class ReportsRoutingModule { }